export const OBJECT_TYPE_MAPPING_ADMIN = {
    climbrole: 1,
    user: 2,
    workgroupuser: 3,
    climbrolefacet: 4
};
